import '@aws-amplify/ui-react/styles.css';
import { Amplify } from 'aws-amplify';
import React from 'react';
import { Route, Routes } from "react-router-dom";
import './App.css';
import Liveness from './Components/Liveness';
import awsexports from './aws-exports';

Amplify.configure(awsexports);

export function App() {

  return (
    <Routes>
      <Route path="/" element={<Liveness />} />
  </Routes>
  );
}

export default App;
